import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// Derived business state about the user's plans. Today it's just the
// "legacy subscription" flag that gates upgrade flows, but anything else
// derived from subscriptions/products that needs to be consumed across the
// app belongs here too.

export interface PlansDataState {
	haveLegacySubscription: boolean;
}

const initialState: PlansDataState = {
	haveLegacySubscription: false,
};

export const plansDataSlice = createSlice({
	name: 'plansData',
	initialState,
	reducers: {
		setHaveLegacySubscription: (state, action: PayloadAction<boolean>) => {
			state.haveLegacySubscription = action.payload;
		},
	},
});

export const { setHaveLegacySubscription } = plansDataSlice.actions;

export default plansDataSlice.reducer;
